import { forwardRef, useMemo } from 'react'
import { Link, useLocation } from 'react-router-dom'

import { NavigationAnchorItem } from './elements'

/**
 * Nav link wrapper; forwards ref to the underlying anchor for click forwarding from parent.
 *
 * @param {Object} props
 * @param {string} props.to - Path to link to
 * @param {string[]} [props.activePaths] - Paths that should be considered active in addition to `to`
 * @param {React.ReactNode} props.children - Icon, label, etc.
 * @param {React.RefObject} ref - Ref forwarded to the anchor element
 * @returns {JSX.Element}
 */
export const NavigationItem = forwardRef(({ to, activePaths = [], children, ...props }, ref) => {
  const { pathname } = useLocation()

  const isActive = useMemo(() => [].concat(to, activePaths).includes(pathname), [pathname, to, activePaths])

  return (
    <NavigationAnchorItem
      ref={ref}
      as={Link}
      isActive={isActive}
      to={to}
      {...props}
    >
      {children}
    </NavigationAnchorItem>
  )
})
